import React, { useState, useEffect } from 'react';
// ✅ WORKING PATTERN:
const API_BASE_URL = "https://final-project-5ar7.onrender.com";
 // ✅ Centralized API base

function DepositRequests() {
  const [deposits, setDeposits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDeposit, setSelectedDeposit] = useState(null);
  const [adminNotes, setAdminNotes] = useState('');
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    fetchDeposits();
  }, []);

  const fetchDeposits = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/all-deposits`);
      const data = await response.json();
      setDeposits(data);
      setLoading(false);
    } catch (error) {
      console.error('❌ Error fetching deposits:', error);
      setLoading(false);
    }
  };

  const handleApprove = async (depositId) => {
    setProcessing(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/approve-deposit/${depositId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ adminNotes })
      });

      if (response.ok) {
        alert('✅ Deposit approved successfully!');
        fetchDeposits();
        setSelectedDeposit(null);
        setAdminNotes('');
      } else {
        const error = await response.json();
        alert(`❌ Error: ${error.message}`);
      }
    } catch (error) {
      console.error('❌ Error approving deposit:', error);
      alert('❌ Network error occurred');
    }
    setProcessing(false);
  };

  const handleReject = async (depositId) => {
    if (!adminNotes.trim()) {
      alert('❌ Please provide rejection reason');
      return;
    }

    setProcessing(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/public/reject-deposit/${depositId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ adminNotes })
      });

      if (response.ok) {
        alert('❌ Deposit rejected');
        fetchDeposits();
        setSelectedDeposit(null);
        setAdminNotes('');
      } else {
        const error = await response.json();
        alert(`❌ Error: ${error.message}`);
      }
    } catch (error) {
      console.error('❌ Error rejecting deposit:', error);
      alert('❌ Network error occurred');
    }
    setProcessing(false);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'submitted': return '#f59e0b';
      case 'pending': return '#3b82f6';
      case 'approved': return '#10b981';
      case 'rejected': return '#ef4444';
      default: return '#6b7280';
    }
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading deposits...</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>Deposit Requests</h1>
      <p>Review and approve pending deposit requests.</p>

      <div style={{ marginTop: '20px' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <thead>
            <tr style={{ background: '#f8fafc' }}>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Date</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>User</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Account</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Amount</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Gateway</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Status</th>
              <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #e2e8f0' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {deposits.map((deposit) => (
              <tr key={deposit._id} style={{ borderBottom: '1px solid #e2e8f0' }}>
                <td style={{ padding: '12px' }}>{new Date(deposit.createdAt).toLocaleDateString()}</td>
                <td style={{ padding: '12px' }}>
                  {deposit.userId?.firstName} {deposit.userId?.lastName}
                  <br />
                  <small style={{ color: '#6b7280' }}>{deposit.userId?.email}</small>
                </td>
                <td style={{ padding: '12px' }}>{deposit.tradeAccount}</td>
                <td style={{ padding: '12px', fontWeight: 'bold' }}>${deposit.amount}</td>
                <td style={{ padding: '12px' }}>{deposit.gateway.replace(/_/g, ' ').toUpperCase()}</td>
                <td style={{ padding: '12px' }}>
                  <span style={{ 
                    background: getStatusColor(deposit.status), 
                    color: 'white', 
                    padding: '4px 8px', 
                    borderRadius: '4px', 
                    fontSize: '12px',
                    textTransform: 'uppercase'
                  }}>
                    {deposit.status}
                  </span>
                </td>
                <td style={{ padding: '12px' }}>
                  {(deposit.status === 'submitted' || deposit.status === 'pending') && (
                    <button 
                      onClick={() => setSelectedDeposit(deposit)}
                      style={{ 
                        background: '#3b82f6', 
                        color: 'white', 
                        border: 'none', 
                        padding: '6px 12px', 
                        borderRadius: '4px', 
                        cursor: 'pointer' 
                      }}
                    >
                      Review
                    </button>
                  )}
                  {deposit.status === 'approved' && (
                    <span style={{ color: '#10b981', fontWeight: 'bold' }}>✅ Approved</span>
                  )}
                  {deposit.status === 'rejected' && (
                    <span style={{ color: '#ef4444', fontWeight: 'bold' }}>❌ Rejected</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ✅ Review Modal remains unchanged */}
      {selectedDeposit && (
        <div style={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          background: 'rgba(0,0,0,0.5)', 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          zIndex: 1000 
        }}>
          <div style={{ 
            background: 'white', 
            padding: '30px', 
            borderRadius: '12px', 
            maxWidth: '600px', 
            width: '90%' 
          }}>
            <h2>Review Deposit Request</h2>
            
            <div style={{ marginBottom: '20px' }}>
              <p><strong>User:</strong> {selectedDeposit.userId?.firstName} {selectedDeposit.userId?.lastName} ({selectedDeposit.userId?.email})</p>
              <p><strong>Trade Account:</strong> {selectedDeposit.tradeAccount}</p>
              <p><strong>Amount:</strong> ${selectedDeposit.amount}</p>
              <p><strong>Gateway:</strong> {selectedDeposit.gateway.replace(/_/g, ' ').toUpperCase()}</p>
              <p><strong>Date:</strong> {new Date(selectedDeposit.createdAt).toLocaleString()}</p>

              {/* ✅ UTR + Payment Slip */}
              {selectedDeposit.utrNumber && (
                <p>
                  <strong>UTR / Reference:</strong>{' '}
                  <span style={{ background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: 4, fontFamily: 'monospace', fontWeight: 'bold' }}>
                    {selectedDeposit.utrNumber}
                  </span>
                </p>
              )}
              {selectedDeposit.paymentSlip?.url && (
                <div style={{ marginTop: 10 }}>
                  <strong>Payment Slip:</strong>
                  <div style={{ marginTop: 8 }}>
                    <a href={selectedDeposit.paymentSlip.url} target="_blank" rel="noreferrer">
                      <img
                        src={selectedDeposit.paymentSlip.url}
                        alt="Payment Slip"
                        style={{ maxWidth: '100%', maxHeight: 240, borderRadius: 8, border: '2px solid #10b981', cursor: 'pointer' }}
                      />
                    </a>
                    <p style={{ fontSize: 12, color: '#6b7280', margin: '4px 0 0' }}>Click image to open full size</p>
                  </div>
                </div>
              )}
              {!selectedDeposit.utrNumber && !selectedDeposit.paymentSlip?.url && (
                <p style={{ color: '#9ca3af', fontSize: 13, fontStyle: 'italic' }}>No payment proof submitted yet</p>
              )}
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
                Admin Notes:
              </label>
              <textarea
                value={adminNotes}
                onChange={(e) => setAdminNotes(e.target.value)}
                placeholder="Add notes (optional for approval, required for rejection)..."
                style={{ 
                  width: '100%', 
                  height: '80px', 
                  padding: '8px', 
                  border: '1px solid #d1d5db', 
                  borderRadius: '4px',
                  resize: 'vertical'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                onClick={() => handleApprove(selectedDeposit._id)}
                disabled={processing}
                style={{ 
                  background: '#10b981', 
                  color: 'white', 
                  border: 'none', 
                  padding: '12px 24px', 
                  borderRadius: '6px', 
                  cursor: processing ? 'not-allowed' : 'pointer',
                  opacity: processing ? 0.6 : 1
                }}
              >
                {processing ? 'Processing...' : '✅ Approve'}
              </button>
              
              <button
                onClick={() => handleReject(selectedDeposit._id)}
                disabled={processing}
                style={{ 
                  background: '#ef4444', 
                  color: 'white', 
                  border: 'none', 
                  padding: '12px 24px', 
                  borderRadius: '6px', 
                  cursor: processing ? 'not-allowed' : 'pointer',
                  opacity: processing ? 0.6 : 1
                }}
              >
                {processing ? 'Processing...' : '❌ Reject'}
              </button>
              
              <button
                onClick={() => {
                  setSelectedDeposit(null);
                  setAdminNotes('');
                }}
                disabled={processing}
                style={{ 
                  background: '#6b7280', 
                  color: 'white', 
                  border: 'none', 
                  padding: '12px 24px', 
                  borderRadius: '6px', 
                  cursor: processing ? 'not-allowed' : 'pointer'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DepositRequests;
